import {
  EntityTypes,
  LitigationAnalyticsService,
} from "@ln/litigationanalytics-abstractions";

export const mapping = new Map<string, EntityTypes>([
  ["federalCourt", EntityTypes.FederalCourt],
  ["stateCourt", EntityTypes.StateCourt],
  ["federalJudge", EntityTypes.FederalJudge],
  ["stateJudge", EntityTypes.StateJudge],
  ["attorney", EntityTypes.Attorney],
  ["lawFirm", EntityTypes.LawFirm],
  ["earlyCaseAssessor", EntityTypes.EarlyCaseAssessor],
  ["compareCourtAndJudges", EntityTypes.CompareCourtAndJudges],
  ["compareCounsel", EntityTypes.CompareCounsel],
  ["party", EntityTypes.Party],
  ["partyGroupLitigationFootprint", EntityTypes.PartyGroupLitigationFootprint],
]);

export function entityTypeForName(typeName: string): EntityTypes {
  const entityType = mapping.get(typeName);
  if (entityType !== undefined) {
    return entityType;
  } else {
    throw new Error(`Unknown entity type: ${typeName}`);
  }
}

export const lexisPlusServices = new LitigationAnalyticsService();
